<template>
  <component :is="layout">
    <div class="site-wrapper content">
      <header
        :class="{
          'site-header': true,
          'site-header-mobile': $http.defaults.isMobileApp
          }">
        <div
          v-if="!$http.defaults.isMobileApp"
          class="wrapper my-2 flex flex-align-items-center site-header-top">
          <button
            id="header-top-mobile-menu-toggle"
            @click.prevent="handleToggleMenu()"
            :class="{'mobile-menu-toggle': true, 'is-open': mobileMenuVisible}">
          </button>

          <template v-if="userLoggedIn">
            <a
              :href="siteDomain"
              target="_blank"
              rel="nofollow noopener noreferrer"
              class="inline-block main-logo-wrapper">
              <img
                v-if="logoPath"
                id="main-logo"
                class="block"
                :src="logoPath"
                :alt="langId === 2 ? $t('general.finPlLogo') : $t('general.finhubLogo')" />
            </a>
          </template>
          <template v-else>
            <a
              :href="siteDomain"
              target="_blank"
              rel="nofollow noopener noreferrer"
              class="inline-block main-logo-wrapper main-logo-wrapper-not-logged-in">
              <img
                v-if="logoPath"
                id="main-logo"
                class="block"
                :src="logoPath"
                :alt="langId === 2 ? $t('general.finPlLogo') : $t('general.finhubLogo')" />
            </a>
          </template>

          <ul
            :class="{
              'site-header-links': true,
              'is-open': mobileMenuVisible
            }">
            <li
              v-for="(item, index) of pageLinks.header"
              :key="'header-nav-item-' + index"
              class="site-header-links-item">
              <a
                :href="siteDomain + item.url"
                class="lnk-big"
                target="_blank"
                rel="nofollow noopener noreferrer"
                @click="handleToggleMenu()">
                {{ item.label }}
              </a>
            </li>
            <template v-if="!userLoggedIn">
              <li class="site-header-links-item not-logged-in-mobile">
                <a
                  :href="siteDomain + pageLinks.offerComparison.url"
                  class="f-btn f-btn-outline-orange ml-0 mt-1 mb-1">
                  {{ pageLinks.offerComparison.label }}
                </a>
              </li>
              <li class="site-header-links-item not-logged-in-mobile">
                <a
                  :href="siteDomain + pageLinks.expertSearch.url"
                  class="f-btn f-btn-outline-blue ml-0">
                  {{ pageLinks.expertSearch.label }}
                </a>
              </li>
            </template>
          </ul>

          <template v-if="userLoggedIn">
            <f-dropdown
              class="ml-auto logged-in-user"
              :text="$t('user.myAccount')"
              type="with-avatar"
              :imgSrc="userAvatarImg"
              :items="userNavItems"/>
          </template>
          <template v-else>
            <a
              :href="siteDomain + pageLinks.offerComparison.url"
              class="f-btn f-btn-outline-orange ml-auto not-logged-in">
              {{ pageLinks.offerComparison.label }}
            </a>

            <a
              :href="siteDomain + pageLinks.expertSearch.url"
              class="f-btn f-btn-outline-blue not-logged-in">
              {{ pageLinks.expertSearch.label }}
            </a>
          </template>
        </div>

        <f-nav
          v-if="userLoggedIn"
          ref="main-nav"
          class="main-nav"
          main
          :items="mainNavItems">

          <f-button
            v-if="$store.getters['getUserType'].toLowerCase() === 'adviser'"
            class="ml-auto"
            theme="inverted"
            :disabled="!userHasCustomersAccess"
            :title="userHasCustomersAccess ? $t('client.addClient') : $t('user.functionUnavailableInCurrentPackage')"
            @click.prevent="$router.push('/klienci/nowy')">
            <f-icon name="add-user" />
            <span class="hidden-small-desktop align-middle">{{ $t('client.addClient') }}</span>
          </f-button>
          <f-button
            :class="{'ml-auto': $store.getters['getUserType'].toLowerCase() === 'customer'}"
            theme="inverted"
            :disabled="!userHasInquiriessAccess"
            :title="userHasCustomersAccess ? $t('dashboard.createOffer') : $t('user.functionUnavailableInCurrentPackage')"
            @click.prevent="$router.push('/oferty-kredytowe/nowa')">
            <f-icon name="edit" />
            <span class="hidden-small-desktop align-middle">
              <template v-if="$store.getters['getUserType'].toLowerCase() === 'customer'">
                {{ $t('dashboard.createQuestion') }}
              </template>
              <template v-else>
                {{ $t('dashboard.createOffer') }}
              </template>
            </span>
          </f-button>
        </f-nav>
      </header>

      <div
        :class="{
          'site-content relative': userLoggedIn,
          'main-login-content my-auto': !userLoggedIn
          }">
        <router-view :key="$route.fullPath" />
      </div>

      <footer
        v-if="!$http.defaults.isMobileApp"
        class="site-footer">
        <div class="site-footer-top-wrapper">
          <div class="site-footer-top wrapper flex py-4 py-3-md">
            <a
              :href="siteDomain"
              target="_blank"
              rel="nofollow noopener noreferrer"
              class="inline-block">
              <img
                v-if="footerLogoPath"
                id="footer-logo"
                class="block"
                :src="footerLogoPath"
                :alt="langId === 2 ? $t('general.finPlLogo') : $t('general.finhubLogo')"
                :style="langId === 2 ? 'filter: brightness(0) invert(1); width: 150px;' : ''"
                loading="lazy" />
            </a>

            <ul class="site-footer-links my-1 mt-3-sm">
              <li
                v-for="(item, index) of pageLinks.footer"
                :key="'footer-nav-item-' + index"
                class="site-footer-links-item">
                <a
                  :href="siteDomain + item.url"
                  class="lnk-big lnk-big-light"
                  target="_blank"
                  rel="nofollow noopener noreferrer">
                  {{ item.label }}
                </a>
              </li>
              <li
                v-if="!$http.defaults.isMobileApp"
                class="site-footer-links-item">
                <f-button
                  theme="lnk-footer"
                  @click.prevent="openCookieSettings">
                  {{ $t('dashboard.cookieSettings') }}
                </f-button>
              </li>
            </ul>
          </div>
        </div>
        <div class="site-footer-bottom wrapper flex flex-align-items-center py-5">
          <ul class="site-footer-social">
            <li class="site-footer-social-icon">
              <a
                :href="pageLinks.facebookUrl"
                class="icon-facebook"
                title="Facebook"
                target="_blank"
                rel="nofollow noopener noreferrer">
                <svg class="icon" >
                  <use xlink:href="@/assets/images/svg/svg-map.svg#facebook"></use>
                </svg>
              </a>
            </li>
            <li class="site-footer-social-icon">
              <a
                :href="pageLinks.linkedInUrl"
                class="icon-linkedin"
                title="LinkedIn"
                target="_blank"
                rel="nofollow noopener noreferrer">
                <svg class="icon" >
                  <use xlink:href="@/assets/images/svg/svg-map.svg#linkedin"></use>
                </svg>
              </a>
            </li>
          </ul>
          <div class="site-footer-info">
            <span>Copyright © {{ new Date().getFullYear() }} Finhub.pl. All rights reserved.</span>
            <span>{{ $t('app.designDevelopment') }}: Safi Studio</span>
          </div>
        </div>
      </footer>
    </div>
  </component>
</template>

<script>
import Vue from 'vue';
import { mapGetters } from 'vuex';
import AppConfig from './.env.js';
import FormUtils from './utils/FormUtils.js';
import FNav from '@/components/layout/FNav.vue';
import getPageLinks from '@/data/page-links';
import getMainNavItems from '@/data/main-nav-items';
import getUserNavItems from '@/data/user-nav-items';
import SanitizeUtils from '@/utils/SanitizeUtils';

export default {
  components: {
    'f-nav': FNav
  },
  data () {
    return {
      mainNavItems: getMainNavItems(),
      pageLinks: getPageLinks(),
      userLoggedIn: false,
      messages: [],
      adviser: null,
      loadedAdviser: false,
      mobileMenuVisible: false
    }
  },
  computed: {
    ...mapGetters({
      siteDomain: 'getSideDomain',
      langId: 'getUserLanguageId'
    }),
    userNavItems () {
      let allItems = getUserNavItems();
      let userPermissions = this.$store.state.user.permissions;

      return allItems.filter(item => userPermissions && (userPermissions[item.permissions] || !item.permissions));
    },
    logoPath () {
      if (this.langId === 1) {
        return require('@/assets/images/FinHubLogo.svg');
      }
      if (this.langId === 2) {
        return require('@/assets/images/FinPLLogo.svg');
      }

      return '';
    },
    footerLogoPath () {
      if (this.langId === 1) {
        return require('@/assets/images/FinHubLogoStopka.svg');
      }
      if (this.langId === 2) {
        return require('@/assets/images/FinPLLogo.svg');
      }

      return '';
    },
    layout () {
      if (!this.$route.meta) {
        return 'default-layout';
      }

      return `${this.$route.meta.layout || 'default'}-layout`;
    },
    messagesCounter () {
      if (!this.messages.length) {
        return { counter: 0, messagesNotRead: 0 };
      }

      let messagesCount = this.messages.reduce((sum, message) => sum + message.messages_count, 0);
      let newMessagesCount = this.messages.reduce((sum, message) => sum + message.new_messages_count, 0);

      return { counter: messagesCount, messagesNotRead: newMessagesCount > 0 };
    },
    userAvatarImg () {
      if (this.adviser && this.adviser.image_url) {
        return this.adviser.image_url
      }

      return require('@/assets/images/default-avatar.png');
    },
    userHasCustomersAccess () {
      return this.$store.getters.getUserHasFeature('customers');
    },
    userHasInquiriessAccess () {
      return this.$store.getters.getUserHasFeature('inquiries');
    }
  },
  mounted () {
    this.$bus.$on('user-logged-in', this.startUserInfoUpdate);
    this.$bus.$on('user-logged-out', this.setUserLoggedOut);
    this.$bus.$on('update-messages-count', this.loadMessages);
    this.getCurrentLanguage();

    let self = this;

    window.crmApp = {
      permissionsAvailable () {
        return self.$store.state && self.$store.state.user && self.$store.state.user.permissions;
      },
      hasPermissions (permissionName) {
        return self.$store.state.user.permissions && self.$store.state.user.permissions[permissionName];
      }
    };

    this.autoRefreshToken();

    Vue.nextTick(() => {
      if (!this.userLoggedIn) {
        if (this.$store.getters['getUserType']) {
          this.startUserInfoUpdate();
        }
      }
    });
  },
  methods: {
    refreshToken () {
      window.localStorage.setItem('last-token-refresh', +new Date());

      FormUtils.submitInBackground(this, {
        endpoint: '/api/auth/generate-token',
        errorTitle: this.$t('ui.errorOccurred'),
        errorText: this.$t('app.restartSessionError'),
        successAction: (response) => {
          this.$http.defaults.headers['X-Csrf-Token'] = `${response.csrf_token}`;
          window.localStorage.setItem('last-token-refresh', +new Date());

          if (AppConfig.isMobileApp) {
            window.localStorage.setItem('fincrm-app-token', response.token);
            Vue.prototype.$http.defaults.headers.Authorization = 'Bearer ' + SanitizeUtils.getToken();
          }
        }
      });
    },
    autoRefreshToken () {
      setTimeout(() => {
        if (this.$store.state && this.$store.state.user && this.$store.state.user.id) {
          let lastRefresh = parseInt(window.localStorage.getItem('last-token-refresh'), 10);

          if (+new Date() - lastRefresh > 30 * 60 * 1000) {
            this.refreshToken();
          }
        }

        this.autoRefreshToken();
      }, 2 * 60 * 1000);
    },
    startUserInfoUpdate () {
      Vue.set(this, 'userLoggedIn', true);

      if (this.$store.getters['getUserType'].toLowerCase() === 'adviser') {
        FormUtils.loadAdditionalData(this, {
          method: 'get',
          endpoint: '/api/adviser/adviser/item',
          loadedKey: 'loadedAdviser',
          outputKey: 'adviser',
          pagination: false
        });
      }

      this.updateUserInfo();
    },
    updateUserInfo () {
      if (this.$store.getters['getUserType']) {
        if (this.$store.getters['getUserType'].toLowerCase() === 'adviser') {
          this.sendActivityUpdate();
        }

        this.loadMessages();
      }

      setTimeout(() => {
        this.updateUserInfo();
      }, 150000);
    },
    sendActivityUpdate () {
      this.$http.post('/api/adviser/adviser/update-last-active', {}).then(() => {
      }).catch((error) => {
        console.log(error);
      });
    },
    loadMessages () {
      FormUtils.loadAdditionalData(this, {
        endpoint: '/api/messages/topics/items',
        method: 'get',
        outputKey: 'messages',
        loadedKey: 'messagesLoaded',
        errorKey: 'loadError',
        successAction: (response) => {
          Vue.set(this, 'messages', response);
          Vue.nextTick(() => {
            if (this.$refs['main-nav']) {
              this.$refs['main-nav'].updateItemCounter(1, this.messagesCounter.counter, this.messagesCounter.messagesNotRead);
            }
          })
        }
      });
    },
    setUserLoggedOut (isFromError = false) {
      if (!isFromError) {
        this.sendActivityUpdate();
      }

      Vue.set(this, 'userLoggedIn', false);
      Vue.set(this, 'adviser', null);
      Vue.set(this, 'loadedAdviser', false);
      Vue.set(this, 'messages', []);
    },
    handleToggleMenu () {
      if ((window.matchMedia('screen and (max-width: 1024px)')).matches) {
        Vue.set(this, 'mobileMenuVisible', !this.mobileMenuVisible);
        if (this.mobileMenuVisible) {
          document.body.classList.add('no-scroll');
          return;
        }
        document.body.classList.remove('no-scroll');
      }
    },
    getCurrentLanguage () {
      this.$http.get('/api/system/languages/current', {}).then((response) => {
        let responseLang = response.data.data;
        this.$store.commit('setUserLanguage', responseLang);
        let currentLanguageID = this.$i18n.locale === 'pl' ? 1 : 2;

        if (responseLang.id > 0 && currentLanguageID !== responseLang.id) {
          window.localStorage.setItem('finhub-panel-ui-language', responseLang.id);
          window.location.reload();
        }
      }).catch((error) => {
        console.log(error);
      });
    },
    openCookieSettings () {
      if (window.Cookiebot) {
        window.Cookiebot.renew();
      }
    }
  },
  beforeDestroy () {
    this.$bus.$off('user-logged-in', this.startUserInfoUpdate);
    this.$bus.$off('user-logged-out', this.setUserLoggedOut);
    this.$bus.$off('update-messages-count', this.loadMessages);
  }
};
</script>
